import { IArticleWithLabel } from "./article";

export const path = '/apic/helpsupport/v1/label'
export interface ILabelAPIResponse {
  articles: IArticleWithLabel[];
}

export interface ILabel {
  id: string;
  name: string;
  displayName: string;
  labelId: string;
  metaTitle?: string;
  metaDesc?: string;
  isSupportCenterLabel?: boolean;
  parentName?: string;
}
